import { createAction } from '@reduxjs/toolkit';
import { ParsedHttpError } from 'types/error';

export const apiRequestFailure = createAction<ParsedHttpError>('error/API_REQUEST_FAILURE');
export const clearErrors = createAction('error/CLEAR_ERRORS');
